import { useEffect, useState } from "react";

export default function PWAInstallPrompt() {
  const [promptEvent, setPromptEvent] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("fpbInstallPromptDismissed") === "yes");

  useEffect(() => {
    const handlePrompt = (event) => {
      event.preventDefault();
      setPromptEvent(event);
    };

    window.addEventListener("beforeinstallprompt", handlePrompt);
    return () => window.removeEventListener("beforeinstallprompt", handlePrompt);
  }, []);

  if (!promptEvent || dismissed) return null;

  const install = async () => {
    promptEvent.prompt();
    await promptEvent.userChoice;
    setPromptEvent(null);
  };

  const close = () => {
    localStorage.setItem("fpbInstallPromptDismissed", "yes");
    setDismissed(true);
  };

  return (
    <aside className="fpb-install-prompt" aria-label="Install website prompt">
      <div>
        <strong>Install FPB website</strong>
        <p>Open notices, departments, downloads and campus information faster from your device.</p>
      </div>
      <button onClick={install}>Install</button>
      <button className="fpb-install-close" onClick={close} aria-label="Dismiss install prompt">×</button>
    </aside>
  );
}
